import React,{Fragment} from 'react';
import ReactTooltip from 'react-tooltip'
import { get } from '../../../server/actions';
import {BeatLoader} from 'react-spinners';
import { _addNotificationError, getGradeNumberByText, 
    groupBy,isRegularLunchOrderType,showFile,getSchoolGrades } from '../../../server/util'
import moment from 'moment';

class PrintEligibility extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            loading:false,
        }
      //  const {downloadPDF} = this.props
    }
    downloadEligibilitySummary =()=>{
        this.props.downloadPDF(true)
        // const districtID = sessionStorage.getItem('districtId');
        // const currentDate = moment().format("YYYY-MM-DD")
        // const url = `/reports/eligibilitySummary?districtId=${districtID}&currentDate=${currentDate}&isExport=true&access_token=`
        // get(url).then((response) => {
        //     if (!response.ok) {
        //         throw Error(response.statusText);
        //     }
        //     console.log('response', response);
        //     this.setState({loading: false});
        //     return response.blob();
        // }).then(blob => {
        //     let filename = "Eligibility Summary Reports for ";
        //     showFile(blob, filename);
        // }).catch(error => {
        //     this.setState({loading: false});
        //     console.log("Download Failed", error)
        // })
    }

    
    render(){
      
        return(<Fragment>
            <div className='sweet-loading'
                         style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000'}}>
                        <BeatLoader
                            size={20}
                            color={'#ea7066'}
                            loading={this.state.loading}
                        />
                </div>
                <a title="Click to Download PDF"
                 style={{    color: "#fff"}} 
                        onClick={() => this.downloadEligibilitySummary()} target='_blank'
                        className="fa fa-file-pdf-o fa-2x QuickReports-PDF pull-right"><i /></a>
        
        </Fragment>);
    }
}
export default PrintEligibility;


// WEBPACK FOOTER //
// ./src/components/District/Home/PrintEligibilitySummary.jsx